module.exports = __webpack_public_path__ + "static/media/apple.b8adff11.png";